module.exports = __webpack_public_path__ + "img/img_my_identify_2.14d8df92.jpg";